import { SnackBarProps } from '@swyftx/aviary/atoms/Snackbar/Snackbar.styles';

import { create } from 'zustand';

type SnackBarState = {
  snackbars: Map<string, SnackBarProps>;
  addSnackBar: (snackBar: SnackBarProps) => void;
  removeSnackBar: (uuid: string) => void;
};

const useSnackBars = create<SnackBarState>()((set) => ({
  snackbars: new Map(),
  addSnackBar: (snackBar: SnackBarProps) => {
    set(({ snackbars }) => {
      const key = Date.now().toString(36) + Math.random().toString(36).substring(2);
      snackbars.set(key, snackBar);
      return { snackbars };
    });
  },
  removeSnackBar: (uuid: string) => {
    set(({ snackbars }) => {
      snackbars.delete(uuid);
      return { snackbars };
    });
  },
}));

export { useSnackBars };
